import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-check",
  "use": "default-check-usage",
  "viewBox": "0 0 68 47",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 47\" id=\"default-check\"><path fill-rule=\"evenodd\" d=\"M24.642 38.592L63.234 0l4.243 4.243L25.05 46.669l-.6-.6-.408.408L0 22.435l4.243-4.243 20.4 20.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol